import {lazy} from 'react';

export const InstitutionDashboard = lazy(() => import('./dashboard'));
